/**
 * Validate an email address string.
 *
 * ⚠️ As ever, email validation is tricky (impossible, really), but it's often helpful to try.
 *
 * @returns {boolean} true if the email address **_looks_** valid
 * @see https://stackoverflow.com/a/46181
 */
export function validateEmailAddress(emailAddress: string): boolean {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    emailAddress,
  )
}

/**
 * Returns true if the domains in each email address are an exact match
 * DOES NOT validate either email address
 *
 * @param a An email address
 * @param b Another email address
 */
export function emailsAreOnSameDomain(a: string, b: string) {
  const domainA = getDomain(a)?.trim()
  const domainB = getDomain(b)?.trim()

  if (!domainA || !domainB) {
    // Just in case
    return false
  }

  return domainA === domainB
}

export function getDomain(email: string) {
  return email.split('@').pop()
}
